import * as I18n from 'i18n-js';
import * as React from 'react';
import { V3 } from '../api_request';
import userRegionUrl from '../shared/user_region_url';
import Article from './article';
import URLHelpers from '../shared/url_helpers';

interface State {
  articles: Article[];
}

export default class NewsNav extends React.Component<null, State> {
  constructor(props) {
    super(props);

    this.state = {
      articles: [],
    };
  }

  componentDidMount() {
    V3.get(URLHelpers.articlesRecentlyFeaturedPath()).then((res) => {
      this.setState({ articles: res.articles });
    });
  }

  renderArticles() {
    return this.state.articles.map((article, index) => {
      return (
        <li key={`article-${index}`}>
          <div className="site-header__menu__item">
            <a
              className="site-header__menu__link"
              href={article._links.web.href}
            >
              <img
                className="img-hoverable"
                src={article._links.mobile_small.href}
                alt={article.title}
              />
              <div className="site-header__menu__item__description">
                {article.title}
              </div>
            </a>
          </div>
        </li>
      );
    });
  }

  render() {
    return (
      <div
        className="site-header__menu site-header__menu--articles"
        data-dropdown
      >
        <div className="site-header__menu__articles">
          <ul>
            {this.renderArticles()}
            <li className="site-header__menu__footer">
              <a className="button button--orange width-100 size-90" href={userRegionUrl('/news')}>
                {I18n.t('discovery.newsDropdown.viewAll')}
              </a>
            </li>
          </ul>
        </div>

        <div className="site-header__menu__article-categories">
          <ul>
            <li>
              <a
                className="site-header__menu__link"
                href={userRegionUrl('/news?category_name=News+and+Reviews')}
              >
                {I18n.t('discovery.newsDropdown.newsAndReviews')}
              </a>
            </li>
            <li>
              <a
                className="site-header__menu__link"
                href={userRegionUrl('/news?category_name=Tips+and+How-To%27s')}
              >
                {I18n.t('discovery.newsDropdown.tips')}
              </a>
            </li>
            <li>
              <a
                className="site-header__menu__link"
                href={userRegionUrl('/news?category_name=Interviews')}
              >
                {I18n.t('discovery.newsDropdown.interviews')}
              </a>
            </li>
            <li>
              <a
                className="site-header__menu__link"
                href={userRegionUrl('/news?category_name=Gear+History')}
              >
                {I18n.t('discovery.newsDropdown.gearHistory')}
              </a>
            </li>
            <li>
              <a
                className="site-header__menu__link"
                href={userRegionUrl('/news?category_name=Demos')}
              >
                {I18n.t('discovery.newsDropdown.demos')}
              </a>
            </li>
            <li>
              <a className="site-header__menu__link" href={userRegionUrl('/videos')}>
                {I18n.t('discovery.newsDropdown.videos')}
              </a>
            </li>
          </ul>
        </div>
      </div>
    );
  }
}



// WEBPACK FOOTER //
// /home/reverb/workspace/core.deploy.production/build/src/node_modules/@reverbdotcom/discovery-ui/src/components/discovery/news_nav.tsx